import { render, staticRenderFns } from "./OverduePlan.vue?vue&type=template&id=264e8668"
import script from "./OverduePlan.vue?vue&type=script&lang=js"
export * from "./OverduePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports